import React from "react";

export const Copy = ({ color, children, fontSize }) => (
  <p
    style={{
      color,
      fontSize: `${fontSize}px` || "12px",
      fontFamily: "AlternateGotNo3D",
      margin: "0",
    }}
  >
    {children}
  </p>
);
